import { useAnalytics } from '@/services/analytics';
import { directUpload } from '@/services/api';
import { AxiosError } from 'axios';
import { useMutation } from 'react-query';

const useDirectUpload = () => {
    const mixpanel = useAnalytics();

    return useMutation(directUpload, {
        onSuccess: () => {
            mixpanel?.track('direct-upload', { event: 'success' });
        },
        onError: (error: AxiosError<{ kind: string; description?: string }>) => {
            const kind = error?.response?.data?.kind;
            mixpanel?.track('direct-upload', { kind, event: 'error' });
        },
    });
};

export default useDirectUpload;
